
/*
* @license
* ANALOG Theme (c) Groupthought Themes
*
* This file is included for advanced development by
* Shopify Agencies. Modified versions of the theme
* code are not supported by Shopify or Groupthought.
*
* Add any minor JS changes in assets/custom.js, this
* will make it easier to update the theme in the future.
*
*/
                  
(function() {
    const env = {"NODE_ENV":"production"};
    try {
        if (process) {
            process.env = Object.assign({}, process.env);
            Object.assign(process.env, env);
            return;
        }
    } catch (e) {} // avoid ReferenceError: process is not defined
    globalThis.process = { env:env };
})();

function isSupported() {
  return typeof HTMLElement !== "undefined" && typeof HTMLElement.prototype === "object" && "popover" in HTMLElement.prototype;
}

function onDocumentReady(callback) {
    if (document.readyState !== 'complete') {
        document.addEventListener('DOMContentLoaded', callback);
    }
    else {
        callback();
    }
}

/*
  Wraps all tables inside .prose elements in a .rte-table-wrapper class
  Watches newly added content for .prose elements and wraps its tables too.
  Tables without any <th> are marked role="presentation" so screen readers
  treat them as layout, not data — RTE editors often emit header-less tables
  for layout, and AT heuristics for unmarked tables are unpredictable.
*/
function wrapTables(container) {
    container.querySelectorAll('.prose table').forEach((table) => {
        if (!table.hasAttribute('role') && !table.querySelector('th')) {
            table.setAttribute('role', 'presentation');
        }
        const wrapperClass = 'rte-table-wrapper';
        const tableAlreadyWrapped = table.closest(`.${wrapperClass}`);
        if (tableAlreadyWrapped)
            return;
        const parent = table.parentNode;
        const wrapper = document.createElement('div');
        wrapper.classList.add(wrapperClass);
        if (parent) {
            parent.insertBefore(wrapper, table);
            wrapper.appendChild(table);
        }
    });
}
// Search the newly added content for .prose tables and wrap them too
let observer = new MutationObserver((mutations) => {
    for (let mutation of mutations) {
        if (mutation.target instanceof HTMLElement) {
            if (mutation.target.classList.contains('prose') && mutation.target.parentNode instanceof HTMLElement) {
                wrapTables(mutation.target.parentNode);
            }
            else {
                wrapTables(mutation.target);
            }
        }
    }
});
observer.observe(document.body, {
    childList: true,
    subtree: true,
});
onDocumentReady(() => {
    // Wrap all initially rendered .prose tables
    wrapTables(document.body);
});

if (!isSupported()) {
    // @ts-ignore
    import('popover-polyfill');
}
